export default __webpack_public_path__ + "static/media/FG_62.83a5775e.jpg";